<template>
  <eden-confirm-dialog
    title="Delete Zone"
    button-type="danger"
    button-text="Delete"
    :show.sync="shouldShow"
    @confirm="deleteMFC"
  >
    <p>
      Are you sure you want to delete the zone,
      <strong>{{ zone.name }}</strong
      >?
    </p>
  </eden-confirm-dialog>
</template>

<script>
import mfc from "@/requests/zones/mfc";

export default {
  name: "MFCDelete",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    zone: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
    },
    deleteMFC() {
      mfc
        .delete(this.zone.id)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.$emit("success");
            this.closeEvent();
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
